import React, { Fragment, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { /* Button, */ Grid, Image, Item, Segment } from 'semantic-ui-react';
import CompressedImage from '../../../app/common/elements/CompressedImage';
import Stars from '../../../app/common/elements/Stars';
import LoadingComponent from '../../../app/layout/LoadingComponent';
import UnauthModal from '../../auth/UnauthModal';
import { fetchReviewsByAppId } from '../libraryActions';
import ApplicationDetailedReviewTable from './ApplicationDetailedReviewTable';

export default function ApplicationDetailedReview() {
  const dispatch = useDispatch();
  const { loading } = useSelector((state) => state.async);
  //const { authenticated } = useSelector((state) => state.auth);
  const { selectedApplication } = useSelector((state) => state.library);
  const { reviews } = useSelector((state) => state.library);
  const [modalOpen, setModalOpen] = useState(false);

  const images = [
    '/assets/images/laptop-man-yes-200.png',
    '/assets/images/laptop-woman-yes-200.png',
  ];

  const randomNumber = Math.floor(Math.random() * 2);
  const imageURL = images[randomNumber];

  // function handleAddReview() {
  //   console.log('Add Review');
  // }

  useEffect(() => {
    dispatch(fetchReviewsByAppId(selectedApplication.id));
  }, [dispatch, selectedApplication.id]);

  if (loading) return <LoadingComponent />;

  const ratings = [
    {
      star: 5,
      percent: Math.round(
        (selectedApplication.Stars_5 / selectedApplication.rating_user) * 100
      ),
    },
    {
      star: 4,
      percent: Math.round(
        (selectedApplication.Stars_4 / selectedApplication.rating_user) * 100
      ),
    },
    {
      star: 3,
      percent: Math.round(
        (selectedApplication.Stars_3 / selectedApplication.rating_user) * 100
      ),
    },
    {
      star: 2,
      percent: Math.round(
        (selectedApplication.Stars_2 / selectedApplication.rating_user) * 100
      ),
    },
    {
      star: 1,
      percent: Math.round(
        (selectedApplication.Stars_1 / selectedApplication.rating_user) * 100
      ),
    },
  ];
  return (
    <Fragment>
      {modalOpen && <UnauthModal setModalOpen={setModalOpen} />}
      <Grid>
        <Grid.Column computer={8} mobile={16} style={{ textAlign: 'center' }}>
          <h1>User Reviews of {selectedApplication.title}</h1>
        </Grid.Column>
        <Grid.Column computer={8} mobile={16} style={{ textAlign: 'center' }}>
          <Image
            src='/assets/images/user-rating-300.png'
            style={{ display: 'inline' }}
          />
        </Grid.Column>
      </Grid>
      {reviews && reviews.length > 0 ? (
        <Grid>
          <Grid.Column width={1}></Grid.Column>
          <Grid.Column width={4}>
            <ApplicationDetailedReviewTable ratings={ratings} />
          </Grid.Column>
          <Grid.Column width={10}>
            {reviews.map((review) => (
              <Segment clearing key={review.id}>
                <Item>
                  <Item.Image
                    size='mini'
                    circular
                    src={review.authorImage || '/assets/user.png'}
                  />{' '}
                  <span style={{ marginLeft: '10px', fontSize: '0.8em' }}>
                    {review.authorName}
                  </span>
                  <Item.Header style={{ marginBottom: 10 }}>
                    <Stars starRating={review.star_rating} />
                    <span style={{ marginLeft: 100 }}>{review.title}</span>
                  </Item.Header>
                  <Item.Description>{review.review_text}</Item.Description>
                </Item>
                <div style={{ fontSize: '0.8em', float: 'right' }}></div>
              </Segment>
            ))}
          </Grid.Column>
          <Grid.Column width={1}></Grid.Column>
        </Grid>
      ) : (
        <Segment clearing style={{ marginBottom: '10px' }}>
          <CompressedImage
            jpf={true}
            jxr={true}
            webp={true}
            src={imageURL}
            style={{
              display: 'flex',
              padding: 20,
              marginLeft: 'auto',
              marginRight: 'auto',
            }}
          />
          <p
            style={{
              fontSize: '1.5em',
              display: 'block',
              textAlign: 'center',
              marginLeft: 'auto',
              marginRight: 'auto',
            }}
          >
            There are no user reviews of {selectedApplication.title} but that
            means you can be the first!!
          </p>
          {/* <p style={{ textAlign: 'center' }}>
            <Button
              content='Add a Review'
              color='teal'
              onClick={
                authenticated ? handleAddReview : () => setModalOpen(true)
              }
              loading={loading}
            />
          </p> */}
        </Segment>
      )}
      <p>&nbsp;</p>
    </Fragment>
  );
}
